/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.0.1
 */

import { createAction } from '../../modules/app/createAction';
import { SET_HELP_FLAG, SET_HELP_FLAG_FAIL, SET_HELP_FLAG_SUCCESS, SET_HELP_TIP_TEXT } from './headerConstants';
import {
    TSetHelpFlagTipsAction,
    TSetHelpFlagTipsFailureAction,
    TSetHelpFlagTipsSuccessAction,
    TSetHelpTipTextAction,
} from './headerTypes';

/*
* -------------------------------------------
*        SET HELP FLAG
* -------------------------------------------
*/

export const setHelpFlagAction = (payload: boolean): TSetHelpFlagTipsAction =>
    createAction(SET_HELP_FLAG, payload);

export const setHelpFlagSuccessAction = (payload: boolean): TSetHelpFlagTipsSuccessAction =>
    createAction(SET_HELP_FLAG_SUCCESS, payload);

export const setHelpFlagFailAction = (payload: string): TSetHelpFlagTipsFailureAction =>
    createAction(SET_HELP_FLAG_FAIL, payload);

/*
* -------------------------------------------
*        SET HELP TIP TEXT
* -------------------------------------------
*/

/**
 * Commonly text for help tip is defined in common translation
 * To change the text dynamically, use this action to override default text
 * @param payload - text for override
 */
export const setHelpTipTextAction = (payload: string): TSetHelpTipTextAction =>
    createAction(SET_HELP_TIP_TEXT, payload);
